// src/api/auth.js
import request from '@/utils/requestWrapper'

// 获取token
export function getToken () {
  // 从store获取token
  const store = window.$store
  return store ? store.state.user.token : null
}

// 设置token
export function setToken (token) {
  // 从store设置token
  const store = window.$store
  if (store) {
    store.commit('user/SET_TOKEN', token)
  }
  return token
}

// 移除token
export function removeToken () {
  // 从store移除token
  const store = window.$store
  if (store) {
    store.commit('user/SET_TOKEN', null)
  }
  return null
}

// 获取用户信息
export function getUserInfo () {
  // 从store获取用户信息
  const store = window.$store
  return store ? store.state.user.userInfo : null
}

// 设置用户信息
export function setUserInfo (userInfo) {
  // 从store设置用户信息
  const store = window.$store
  if (store) {
    store.commit('user/SET_USER_INFO', userInfo)
  }
  return userInfo
}

// 移除用户信息
export function removeUserInfo () {
  // 从store移除用户信息
  const store = window.$store
  if (store) {
    store.commit('user/SET_USER_INFO', null)
  }
  return null
}

// 清除所有认证信息
export function clearAuth () {
  removeToken()
  removeUserInfo()
  // 从store设置登录状态
  const store = window.$store
  if (store) {
    store.commit('user/SET_LOGIN_STATUS', false)
  }
}

// 登录 → 【修复版】 
export const login = (user) => { 
  return request({ 
    url: '/api/auth/login', 
    method: 'POST', 
    data: { 
      // 🔥 只传后端真正要的字段！ 
      usernameOrPhone: user.phone || user.usernameOrPhone || '', 
      password: user.password || '' 
    } 
  }) 
 }

// 注册 → 统一认证服务
export const registerUser = (user) => {
  console.log('registerUser - 接收到的参数:', user)
  const requestData = {
    username: user.username || user.phone || '',
    phone: user.phone || '',
    password: user.password || '',
    confirmPassword: user.confirmPassword || '',
    email: user.email || null,
    avatar: user.avatar || null
  }

  // ✅ 如果有 shareId，传递给后端建立推荐关系
  if (user.shareId) {
    requestData.shareId = user.shareId
    console.log('registerUser - 携带shareId:', user.shareId)
  }

  // ✅ 同时支持商城 spread 参数（纯数字 CRMEB uid）
  // 优先用显式传入，其次查 localStorage，最后查 URL
  let spread = user.spread || null
  if (!spread && typeof localStorage !== 'undefined') {
    spread = localStorage.getItem('pendingSpread')
  }
  if (!spread && typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search)
    spread = urlParams.get('spread')
    const shareIdFromUrl = urlParams.get('share_id')
    if (shareIdFromUrl && !requestData.shareId) {
      requestData.shareId = shareIdFromUrl
      console.log('registerUser - 从URL取到share_id:', shareIdFromUrl)
    }
  }
  if (spread) {
    requestData.spread = spread
    console.log('registerUser - 携带spread:', spread)
  }

  return request({
    url: '/api/auth/register',
    method: 'POST',
    data: requestData
  })
}

// 短信登录 → 统一认证服务
export const smsLogin = (user) => {
  return request({
    url: '/api/auth/login-with-code',
    method: 'POST',
    params: {
      phone: user.phone,
      code: user.code
    }
  })
}

// 发送短信验证码 → 统一认证服务
export const sendSmsCode = (phone, codeType = 'LOGIN') => {
  return request({
    url: '/api/auth/send-code',
    method: 'POST',
    data: {
      phone: phone,
      codeType: codeType
    }
  })
}

// 刷新令牌 → 统一认证服务
export const refreshToken = (refreshToken) => {
  // 暂时返回成功，后端暂无此接口
  return Promise.resolve({ code: 200, message: 'Token刷新成功', data: { token: refreshToken } });
}

// 登出 → 统一认证服务
export const logout = () => {
  // 暂时返回成功，后端暂无此接口
  return Promise.resolve({ code: 200, message: '登出成功', data: null });
}

// 修改密码 → 统一认证服务
export const changePassword = (userId, oldPassword, newPassword) => {
  // 使用更新用户接口替代，后端暂无专门的密码修改接口
  return request({
    url: '/api/user/update',
    method: 'PUT',
    data: {
      id: userId,
      password: newPassword
    }
  })
}

// 重置密码（需要验证码）→ 统一认证服务
export const resetPassword = (phone, code, newPassword) => {
  return request({
    url: '/api/auth/reset-password',
    method: 'POST',
    data: {
      phone: phone,
      code: code,
      newPassword: newPassword
    }
  })
}

// 重置密码（仅手机号）→ 统一认证服务
export const resetPasswordByPhone = (phone, newPassword) => {
  return request({
    url: '/api/auth/reset-password-by-phone',
    method: 'POST',
    data: {
      phone: phone,
      newPassword: newPassword
    }
  })
}

// 微信登录 → 统一认证服务
export const wechatLogin = (code) => {
  return request({
    url: '/api/auth/wechat/login',
    method: 'POST',
    params: {
      code: code
    }
  })
}

// 绑定微信 → 统一认证服务
export const bindWechat = (code) => {
  return request({
    url: '/api/auth/wechat/bind',
    method: 'POST',
    params: {
      code: code
    }
  })
}

// 解绑微信 → 统一认证服务
export const unbindWechat = () => {
  return request({
    url: '/api/auth/wechat/unbind',
    method: 'POST'
  })
}

// ====== 推荐关系 / 分享相关 —— 名片后端 ======

/**
 * 生成/获取当前用户的 shareId（格式: share_{userId}_{8位随机串}）
 * 名片后端 RelationController.GET /api/relation/share-id?userId=xxx
 */
export const generateShareId = (userId) => {
  return request({
    url: '/api/relation/share-id',
    method: 'GET',
    params: { userId }
  })
}

/**
 * 绑定推荐关系（已登录用户通过分享链接访问时调用）
 * 名片后端 RelationController.POST /api/relation/bind
 *
 * @param {string} shareId  分享链接里带的 share_id
 * @param {number|string} currentUserId  当前登录用户ID
 */
export const bindRelation = (shareId, currentUserId) => {
  return request({
    url: '/api/relation/bind',
    method: 'POST',
    params: { shareId, currentUserId }
  })
}